(function () {
  'use strict';

  if (window.PMYTracking) return;

  /* PMY 2026-10-14: remember where this file was served from, so the click and
     form scripts (micro/deep) can load right after it. */
  var SELF_SCRIPT = document.currentScript;

  var SESSION_ATTR_KEY = 'pmy_attribution_v1';
  var SESSION_ID_KEY = 'pmy_session_id_v1';
  var PERSIST_KEY = 'pmy_attribution_persist_v1';
  var PERSIST_MS = 90 * 24 * 60 * 60 * 1000;
  var ACQ_KEYS = [
    'utm_source','utm_medium','utm_campaign','utm_term','utm_content','utm_id',
    'gclid','dclid','gbraid','wbraid','fbclid','msclkid','ttclid',
    'source','ref','r'
  ];
  var CLICK_IDS = ['gclid','dclid','gbraid','wbraid','fbclid','msclkid','ttclid'];
  var MAX_ATTR_VALUE = 250;
  var nativeFetch = window.fetch;

  function storageGet(storage, key) {
    try { return storage.getItem(key); } catch (e) { return null; }
  }

  function storageSet(storage, key, value) {
    try { storage.setItem(key, value); } catch (e) {}
  }

  function storageRemove(storage, key) {
    try { storage.removeItem(key); } catch (e) {}
  }

  function parseJSON(raw, fallback) {
    try { return raw ? JSON.parse(raw) : fallback; } catch (e) { return fallback; }
  }

  function clean(value, max) {
    if (value === null || value === undefined) return '';
    value = String(value).trim();
    if (!value) return '';
    return value.slice(0, max || 500);
  }

  function nowISO() {
    try { return new Date().toISOString(); } catch (e) { return ''; }
  }

  function createSessionId() {
    var existing = storageGet(sessionStorage, SESSION_ID_KEY);
    if (existing) return existing;
    var id = 'pmy_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12);
    storageSet(sessionStorage, SESSION_ID_KEY, id);
    return id;
  }

  function locale() {
    return clean(document.documentElement.lang || '');
  }

  function destination() {
    var value = clean(
      document.documentElement.getAttribute('data-pmy-destination') ||
      (document.body && document.body.getAttribute('data-pmy-destination')) || ''
    ).toLowerCase();
    if (value === 'italia') value = 'italy';
    return value || 'portugal';
  }

  function currency() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) return clean(Shopify.currency.active, 10);
    } catch (e) {}
    var select = document.getElementById('pmy-currency-select');
    if (select && select.selectedOptions && select.selectedOptions[0]) {
      var text = clean(select.selectedOptions[0].textContent, 20);
      var match = text.match(/^([A-Z]{3})\b/);
      if (match) return match[1];
    }
    var htmlCode = clean(document.documentElement.getAttribute('data-pmy-currency-code'), 10);
    return htmlCode;
  }

  function currentParams() {
    var out = {};
    var params = new URLSearchParams(window.location.search || '');
    ACQ_KEYS.forEach(function (key) {
      var value = params.get(key);
      if (value) out[key] = clean(value, 500);
    });
    return out;
  }

  function hasAcquisition(params) {
    return ACQ_KEYS.some(function (key) { return !!params[key]; });
  }

  function externalReferrer() {
    if (!document.referrer) return '';
    try {
      var ref = new URL(document.referrer);
      if (ref.hostname === window.location.hostname) return '';
      return clean(document.referrer, 500);
    } catch (e) {
      return '';
    }
  }

  function sourceFrom(params, referrer) {
    var source = clean(params.utm_source, 100);
    var medium = clean(params.utm_medium, 100);

    if (!source && params.source) source = clean(params.source, 100);

    if (!source) {
      if (params.gclid || params.dclid || params.gbraid || params.wbraid) source = 'google';
      else if (params.fbclid) source = 'facebook';
      else if (params.msclkid) source = 'microsoft';
      else if (params.ttclid) source = 'tiktok';
      else if (referrer) {
        try { source = new URL(referrer).hostname.replace(/^www\./, ''); } catch (e) {}
      }
    }

    if (!medium) {
      if (params.gclid || params.dclid || params.gbraid || params.wbraid || params.msclkid) medium = 'cpc';
      else if (params.fbclid || params.ttclid) medium = 'paid_social';
      else if (referrer) medium = 'referral';
    }

    if (!source) source = 'direct';
    if (!medium) medium = '(none)';
    return { source: source, medium: medium };
  }

  function makeTouch(params, referrer) {
    var sm = sourceFrom(params, referrer);
    var touch = {
      source: sm.source,
      medium: sm.medium,
      campaign: clean(params.utm_campaign, 200),
      term: clean(params.utm_term, 200),
      content: clean(params.utm_content, 200),
      campaign_id: clean(params.utm_id, 200),
      referral_code: clean(params.ref || params.r || params.source, 200),
      referrer: clean(referrer, 500),
      captured_at: nowISO()
    };
    CLICK_IDS.forEach(function (key) {
      if (params[key]) touch[key] = clean(params[key], 500);
    });
    return touch;
  }

  function hostFrom(value) {
    if (!value) return '';
    try { return new URL(value).hostname.toLowerCase().replace(/^www\./, ''); } catch (e) { return ''; }
  }

  function hasAny(value, terms) {
    value = clean(value, 1000).toLowerCase();
    return terms.some(function (term) { return value.indexOf(term) !== -1; });
  }

  function paidMedium(medium) {
    return /^(cpc|ppc|paid|paid_search|paid-social|paid_social|display|cpm)$/i.test(clean(medium, 100));
  }

  function orderReferrerIdentity(a) {
    var touch = (a && a.last_touch) || (a && a.first_touch) || {};
    var rawSource = clean(touch.source, 100).toLowerCase();
    var medium = clean(touch.medium, 100).toLowerCase();
    var referrer = clean(touch.referrer, 500);
    var host = hostFrom(referrer);
    var referralCode = clean(touch.referral_code, 200);
    var hay = [rawSource, host, referralCode].join(' ').toLowerCase();
    var paid = paidMedium(medium) || !!(touch.gclid || touch.dclid || touch.gbraid || touch.wbraid || touch.fbclid || touch.msclkid || touch.ttclid);

    if (hasAny(hay, ['google', 'googleadservices', 'doubleclick']) || touch.gclid || touch.dclid || touch.gbraid || touch.wbraid) {
      return { source: 'google', name: 'Google', channel: paid ? 'paid_search' : 'organic_search', referral_code: referralCode };
    }
    if (hasAny(hay, ['instagram', 'l.instagram.com']) || rawSource === 'ig') {
      return { source: 'instagram', name: 'Instagram', channel: paid ? 'paid_social' : 'organic_social', referral_code: referralCode };
    }
    if (hasAny(hay, ['facebook', 'l.facebook.com', 'fb.com']) || touch.fbclid || rawSource === 'fb' || rawSource === 'meta') {
      return { source: 'facebook', name: 'Facebook', channel: paid ? 'paid_social' : 'organic_social', referral_code: referralCode };
    }
    if (hasAny(hay, ['whatsapp', 'wa.me', 'api.whatsapp.com'])) {
      return { source: 'whatsapp', name: 'WhatsApp', channel: 'messaging', referral_code: referralCode };
    }
    if (hasAny(hay, ['tiktok']) || touch.ttclid) {
      return { source: 'tiktok', name: 'TikTok', channel: paid ? 'paid_social' : 'organic_social', referral_code: referralCode };
    }
    if (hasAny(hay, ['bing', 'microsoft']) || touch.msclkid) {
      return { source: 'microsoft', name: 'Microsoft / Bing', channel: paid ? 'paid_search' : 'organic_search', referral_code: referralCode };
    }
    if (/^(email|e-mail|newsletter)$/i.test(medium) || hasAny(rawSource, ['mailchimp', 'klaviyo', 'resend'])) {
      return { source: rawSource || 'email', name: 'Email', channel: 'email', referral_code: referralCode };
    }
    if (referralCode || /^(affiliate|affiliates|partner|partners)$/i.test(medium) || hasAny(rawSource, ['affiliate', 'partner'])) {
      return { source: 'partner', name: referralCode || rawSource || host || 'Partner', channel: 'partner', referral_code: referralCode };
    }
    if (!rawSource || rawSource === 'direct' || rawSource === '(direct)') {
      return { source: 'direct', name: 'Direct', channel: 'direct', referral_code: referralCode };
    }
    if (host) {
      return { source: 'referral', name: host, channel: 'referral', referral_code: referralCode };
    }
    return { source: rawSource || 'unknown', name: rawSource || 'Unknown', channel: medium && medium !== '(none)' ? medium : 'other', referral_code: referralCode };
  }

  function commercialSource(identity) {
    identity = identity || {};
    var source = clean(identity.source, 100).toLowerCase();
    var channel = clean(identity.channel, 100).toLowerCase();

    if (source === 'google') return channel === 'paid_search' ? 'Google Ads' : 'Google Organic';
    if (source === 'instagram') return 'Instagram';
    if (source === 'facebook') return 'Facebook';
    if (source === 'whatsapp') return 'WhatsApp';
    if (source === 'tiktok') return 'TikTok';
    if (source === 'microsoft') return channel === 'paid_search' ? 'Microsoft Ads' : 'Referência';
    if (channel === 'email') return 'Email';
    if (source === 'partner' || channel === 'partner') return 'Parceiro';
    if (source === 'direct' || channel === 'direct') return 'Site';
    if (source === 'referral' || channel === 'referral') return 'Referência';
    return source && source !== 'unknown' ? 'Outro' : 'Site';
  }

  function loadPersistent() {
    var stored = parseJSON(storageGet(localStorage, PERSIST_KEY), null);
    if (!stored) return null;
    if (stored.expires_at && Number(stored.expires_at) < Date.now()) {
      storageRemove(localStorage, PERSIST_KEY);
      return null;
    }
    return stored;
  }

  function savePersistent(value) {
    value.expires_at = Date.now() + PERSIST_MS;
    storageSet(localStorage, PERSIST_KEY, JSON.stringify(value));
  }

  function buildAttribution() {
    var sessionStored = parseJSON(storageGet(sessionStorage, SESSION_ATTR_KEY), {}) || {};
    var persistent = loadPersistent() || {};
    var params = currentParams();
    var referrer = externalReferrer();
    var signal = hasAcquisition(params) || !!referrer;
    var currentTouch = makeTouch(params, referrer);

    var firstTouch = persistent.first_touch || sessionStored.first_touch || currentTouch;
    var lastTouch = persistent.last_touch || sessionStored.last_touch || firstTouch;
    var firstEntryPath = persistent.first_entry_path || sessionStored.first_entry_path || clean(window.location.pathname + window.location.search, 1000);
    var firstEntryUrl = persistent.first_entry_url || sessionStored.first_entry_url || clean(window.location.href, 1000);
    var firstEnteredAt = persistent.first_entered_at || sessionStored.first_entered_at || nowISO();

    if (signal) {
      if (!persistent.first_touch || persistent.first_touch.source === 'direct') {
        firstTouch = currentTouch;
        firstEntryPath = clean(window.location.pathname + window.location.search, 1000);
        firstEntryUrl = clean(window.location.href, 1000);
        firstEnteredAt = nowISO();
      }
      lastTouch = currentTouch;
    }

    savePersistent({
      first_touch: firstTouch,
      last_touch: lastTouch,
      first_entry_path: firstEntryPath,
      first_entry_url: firstEntryUrl,
      first_entered_at: firstEnteredAt
    });

    var attribution = {
      version: 2,
      session_id: createSessionId(),
      entry_url: sessionStored.entry_url || clean(window.location.href, 1000),
      entry_path: sessionStored.entry_path || clean(window.location.pathname + window.location.search, 1000),
      initial_referrer: sessionStored.initial_referrer !== undefined ? sessionStored.initial_referrer : clean(document.referrer, 500),
      entered_at: sessionStored.entered_at || nowISO(),
      first_touch: firstTouch,
      last_touch: lastTouch,
      first_entry_path: firstEntryPath,
      first_entry_url: firstEntryUrl,
      first_entered_at: firstEnteredAt,
      current_url: clean(window.location.href, 1000),
      current_path: clean(window.location.pathname + window.location.search, 1000),
      locale: locale(),
      destination: destination(),
      updated_at: nowISO()
    };

    storageSet(sessionStorage, SESSION_ATTR_KEY, JSON.stringify(attribution));
    return attribution;
  }

  var attribution = buildAttribution();

  function refreshAttribution() {
    attribution.current_url = clean(window.location.href, 1000);
    attribution.current_path = clean(window.location.pathname + window.location.search, 1000);
    attribution.locale = locale();
    attribution.destination = destination();
    attribution.updated_at = nowISO();
    storageSet(sessionStorage, SESSION_ATTR_KEY, JSON.stringify(attribution));
    return attribution;
  }

  function pageType() {
    var path = window.location.pathname || '/';
    if (document.querySelector('.pdp-container') || /\/products\//.test(path)) return 'product';
    if (/\/collections\//.test(path)) return 'collection';
    if (/\/search/.test(path)) return 'search';
    if (/\/pages\//.test(path)) return 'page';
    if (path === '/' || /^\/[a-z]{2}(?:-[a-z]{2})?\/?$/i.test(path)) return 'home';
    return 'other';
  }

  function trackingContext() {
    var a = refreshAttribution();
    var referrerIdentity = orderReferrerIdentity(a);
    return {
      pmy_session_id: a.session_id,
      pmy_page_type: pageType(),
      pmy_locale: a.locale,
      pmy_destination: a.destination,
      pmy_first_source: a.first_touch && a.first_touch.source || '',
      pmy_first_medium: a.first_touch && a.first_touch.medium || '',
      pmy_first_campaign: a.first_touch && a.first_touch.campaign || '',
      pmy_last_source: a.last_touch && a.last_touch.source || '',
      pmy_last_medium: a.last_touch && a.last_touch.medium || '',
      pmy_last_campaign: a.last_touch && a.last_touch.campaign || '',
      order_referrer_source: referrerIdentity.source,
      order_referrer_name: referrerIdentity.name,
      order_referrer_channel: referrerIdentity.channel,
      commercial_source: commercialSource(referrerIdentity),
      page_path: window.location.pathname,
      page_location: window.location.href
    };
  }

  var FORM_STATE_KEY = 'pmy_form_funnel_v1';

  function readFormState() {
    try {
      var raw = sessionStorage.getItem(FORM_STATE_KEY);
      var data = raw ? JSON.parse(raw) : {};
      return data && typeof data === 'object' ? data : {};
    } catch (e) {
      return {};
    }
  }

  function writeFormState(state) {
    try {
      sessionStorage.setItem(FORM_STATE_KEY, JSON.stringify(state || {}));
    } catch (e) {}
  }

  function rememberFormStart(formName) {
    formName = clean(formName || 'unknown_form', 100);
    if (!formName) return;
    var state = readFormState();
    if (!state[formName]) {
      state[formName] = {
        started_at: new Date().toISOString(),
        page_path: window.location.pathname
      };
      writeFormState(state);
    }
  }

  function clearFormState(formName) {
    formName = clean(formName || '', 100);
    if (!formName) return false;
    var state = readFormState();
    if (!state[formName]) return false;
    delete state[formName];
    writeFormState(state);
    return true;
  }

  function event(name, params) {
    if (!name) return;
    if (String(name).toLowerCase() === 'purchase') return;
    if (name === 'pmy_form_start') {
      rememberFormStart(params && params.form_name);
    } else if (name === 'pmy_form_complete' || name === 'pmy_form_abandon') {
      clearFormState(params && params.form_name);
    }
    window.dataLayer = window.dataLayer || [];
    var payload = {};
    var context = trackingContext();
    Object.keys(context).forEach(function (key) { payload[key] = context[key]; });
    if (params && params.ecommerce) window.dataLayer.push({ ecommerce: null });
    if (params) Object.keys(params).forEach(function (key) { payload[key] = params[key]; });
    payload.event = name;
    window.dataLayer.push(payload);
  }

  function getTouchValue(key) {
    var a = refreshAttribution();
    return clean((a.last_touch && a.last_touch[key]) || (a.first_touch && a.first_touch[key]) || '', MAX_ATTR_VALUE);
  }

  function orderAttributes() {
    var a = refreshAttribution();
    var referrerIdentity = orderReferrerIdentity(a);
    var rows = [
      ['order_referrer_source', referrerIdentity.source],
      ['order_referrer_name', referrerIdentity.name],
      ['order_referrer_channel', referrerIdentity.channel],
      ['PMY Commercial Source', commercialSource(referrerIdentity)],
      ['PMY Referral Code', referrerIdentity.referral_code],
      ['PMY Session', a.session_id],
      ['PMY First Source', a.first_touch && a.first_touch.source],
      ['PMY First Medium', a.first_touch && a.first_touch.medium],
      ['PMY First Campaign', a.first_touch && a.first_touch.campaign],
      ['PMY First UTM Term', a.first_touch && a.first_touch.term],
      ['PMY First UTM Content', a.first_touch && a.first_touch.content],
      ['PMY Last Source', a.last_touch && a.last_touch.source],
      ['PMY Last Medium', a.last_touch && a.last_touch.medium],
      ['PMY Last Campaign', a.last_touch && a.last_touch.campaign],
      ['PMY Last UTM Term', a.last_touch && a.last_touch.term],
      ['PMY Last UTM Content', a.last_touch && a.last_touch.content],
      ['PMY UTM Source', getTouchValue('source')],
      ['PMY UTM Medium', getTouchValue('medium')],
      ['PMY UTM Campaign', getTouchValue('campaign')],
      ['PMY UTM Term', getTouchValue('term')],
      ['PMY UTM Content', getTouchValue('content')],
      ['PMY UTM ID', getTouchValue('campaign_id')],
      ['PMY GCLID', getTouchValue('gclid')],
      ['PMY GBRAID', getTouchValue('gbraid')],
      ['PMY WBRAID', getTouchValue('wbraid')],
      ['PMY FBCLID', getTouchValue('fbclid')],
      ['PMY MSCLKID', getTouchValue('msclkid')],
      ['PMY TTCLID', getTouchValue('ttclid')],
      ['PMY First Landing', a.first_entry_path],
      ['PMY Landing', a.entry_path],
      ['PMY Referrer', a.initial_referrer],
      ['PMY Locale', a.locale],
      ['PMY Destination', a.destination],
      ['PMY Entry Time', a.entered_at]
    ];
    return rows.filter(function (row) { return !!clean(row[1]); }).map(function (row) {
      return { name: row[0], value: clean(row[1], MAX_ATTR_VALUE) };
    });
  }

  function getItemCount(items) {
    if (!Array.isArray(items)) return 0;
    return items.reduce(function (sum, item) {
      return sum + (parseInt(item && item.quantity, 10) || 0);
    }, 0);
  }

  /* ---------------------------------------------------------------------------
     PMY 2026-10-14: one product ID across the whole funnel.
     item_id is always the product handle (the same value select_item,
     view_item_list and view_item already use). Name, price, category and
     ticket type come from Shopify's own cart response, not from page text.
     --------------------------------------------------------------------------- */
  var LINE_CACHE_KEY = 'pmy_cart_lines_v1';

  function money(cents) {
    var n = Number(cents);
    if (!isFinite(n)) return undefined;
    return Math.round(n) / 100;
  }

  function roundMoney(value) {
    return Math.round(value * 100) / 100;
  }

  function handleFromPath(path) {
    var match = String(path || '').split('?')[0].match(/\/products\/([^\/?#]+)/);
    return match ? clean(decodeURIComponent(match[1]), 200) : '';
  }

  function readLineCache() {
    var data = parseJSON(storageGet(sessionStorage, LINE_CACHE_KEY), {});
    return data && typeof data === 'object' ? data : {};
  }

  function writeLineCache(cache) {
    storageSet(sessionStorage, LINE_CACHE_KEY, JSON.stringify(cache || {}));
  }

  function itemFromCartLine(line) {
    if (!line) return null;
    var handle = clean(line.handle, 200) || handleFromPath(line.url);
    var variantId = line.variant_id || line.id;
    var unit = money(line.final_price !== undefined ? line.final_price : line.price);
    var item = {
      item_id: handle || (variantId ? String(variantId) : ''),
      item_name: clean(line.product_title || line.title, 200),
      item_variant: clean(line.variant_title, 100),
      item_category: clean(line.product_type, 100),
      item_category2: destination(),
      item_product_id: line.product_id ? String(line.product_id) : '',
      item_variant_id: variantId ? String(variantId) : '',
      quantity: parseInt(line.quantity, 10) || 0
    };
    if (unit !== undefined) item.price = unit;
    Object.keys(item).forEach(function (key) {
      if (item[key] === '' || item[key] === undefined) delete item[key];
    });
    return item.item_id ? item : null;
  }

  function rememberCartLines(lines) {
    if (!Array.isArray(lines) || !lines.length) return;
    var cache = readLineCache();
    lines.forEach(function (line) {
      var item = itemFromCartLine(line);
      if (item && item.item_variant_id) cache[item.item_variant_id] = item;
    });
    writeLineCache(cache);
  }

  function linesFromAddResponse(body) {
    if (!body || typeof body !== 'object') return [];
    if (Array.isArray(body.items)) return body.items;
    if (body.variant_id || body.id) return [body];
    return [];
  }

  function itemsWithValue(lines) {
    var items = [];
    var total = 0;
    var hasPrice = false;
    (lines || []).forEach(function (line) {
      var item = itemFromCartLine(line);
      if (!item) return;
      items.push(item);
      var lineTotal = line && line.final_line_price !== undefined ? money(line.final_line_price) :
        (item.price !== undefined ? item.price * (item.quantity || 0) : undefined);
      if (lineTotal !== undefined) {
        total += lineTotal;
        hasPrice = true;
      }
    });
    return { items: items, value: hasPrice ? roundMoney(total) : undefined };
  }

  function checkoutItemsWithValue(items) {
    var cache = readLineCache();
    var out = [];
    var total = 0;
    var hasPrice = true;
    (Array.isArray(items) ? items : []).forEach(function (row) {
      var variantId = row && (row.variant_id || row.id);
      var quantity = parseInt(row && row.quantity, 10) || 0;
      if (!variantId) return;
      var cached = cache[String(variantId)];
      var item;
      if (cached) {
        item = JSON.parse(JSON.stringify(cached));
        item.quantity = quantity;
      } else {
        item = { item_id: String(variantId), item_variant_id: String(variantId), item_category2: destination(), quantity: quantity };
      }
      if (item.price !== undefined) total += item.price * quantity;
      else hasPrice = false;
      out.push(item);
    });
    return { items: out, value: out.length && hasPrice ? roundMoney(total) : undefined };
  }

  /* Fallback only: used when Shopify did not return prices. */
  function currentValue() {
    var el = document.getElementById('calc-total') || document.getElementById('gp-calc-total') ||
      document.getElementById('bottom-total-price') || document.getElementById('total-price-display') ||
      document.querySelector('.checkout-price-display .price-value');
    if (!el) return undefined;
    var text = String(el.textContent || '').replace(/\s/g, '');
    var num = text.replace(/[^0-9,.-]/g, '');
    if (!num) return undefined;
    if (num.indexOf(',') > -1 && num.indexOf('.') > -1) {
      if (num.lastIndexOf(',') > num.lastIndexOf('.')) num = num.replace(/\./g, '').replace(',', '.');
      else num = num.replace(/,/g, '');
    } else if (num.indexOf(',') > -1) {
      num = num.replace(',', '.');
    }
    var value = parseFloat(num);
    return isFinite(value) ? value : undefined;
  }

  function orderAttributesObject() {
    var out = {};
    orderAttributes().forEach(function (row) {
      if (!row || !row.name || row.value === null || row.value === undefined) return;
      out[String(row.name)] = String(row.value);
    });
    return out;
  }

  function cartUpdateUrl() {
    try {
      var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      return root + 'cart/update.js';
    } catch (e) {
      return '/cart/update.js';
    }
  }

  /* PMY 2026-10-14: remember the last failed request of the booking flow, so a
     checkout error can say which step broke (availability, cart, etc.). */
  var lastFlowFailure = null;

  function flowStep(url) {
    if (/storefront-hold/.test(url)) return 'availability_hold';
    if (/\/cart\/clear\.js(?:\?|$)/.test(url)) return 'cart_clear';
    if (/\/cart\/add\.js(?:\?|$)/.test(url)) return 'cart_add';
    if (/\/cart\/update\.js(?:\?|$)/.test(url)) return 'cart_update';
    return '';
  }

  function recordFlowFailure(step, status) {
    lastFlowFailure = { step: step, status: status || 0, at: Date.now() };
  }

  function patchFetch() {
    if (!nativeFetch || window.__pmyFetchPatched) return;
    window.__pmyFetchPatched = true;

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var step = flowStep(url);
      var isCartAdd = step === 'cart_add';

      var promise = nativeFetch.call(this, input, init);

      if (step) {
        promise.then(function (response) {
          if (!response || !response.ok) recordFlowFailure(step, response ? response.status : 0);
        }, function () {
          recordFlowFailure(step, 0);
        });
      }

      if (isCartAdd) {
        return promise.then(function (response) {
          if (!response.ok) return response;

          return response.clone().json().catch(function () { return null; }).then(function (body) {
            var lines = linesFromAddResponse(body);
            rememberCartLines(lines);
            var summary = itemsWithValue(lines);
            var value = summary.value !== undefined ? summary.value : currentValue();
            event('add_to_cart', {
              checkout_type: 'shopify_native',
              item_count: getItemCount(summary.items),
              value: value,
              currency: currency(),
              ecommerce: { currency: currency(), value: value, items: summary.items }
            });

            var attrs = orderAttributesObject();
            if (!Object.keys(attrs).length) return response;

            return nativeFetch.call(window, cartUpdateUrl(), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ attributes: attrs })
            }).then(function (attributeResponse) {
              event(attributeResponse && attributeResponse.ok ? 'pmy_cart_attribution_saved' : 'pmy_cart_attribution_error', {
                checkout_type: 'shopify_native',
                http_status: attributeResponse ? attributeResponse.status : 0,
                attribute_count: Object.keys(attrs).length
              });
              return response;
            }).catch(function () {
              event('pmy_cart_attribution_error', {
                checkout_type: 'shopify_native',
                error_type: 'network',
                attribute_count: Object.keys(attrs).length
              });
              return response;
            });
          });
        });
      }

      return promise;
    };
  }

  function patchLocalizationSubmit() {
    if (!window.HTMLFormElement || window.__pmyFormSubmitPatched) return;
    window.__pmyFormSubmitPatched = true;
    var originalSubmit = HTMLFormElement.prototype.submit;
    HTMLFormElement.prototype.submit = function () {
      if (this && this.id === 'localization_form_header') {
        var field = this.querySelector('[name="return_to"]');
        if (!field) {
          field = document.createElement('input');
          field.type = 'hidden';
          field.name = 'return_to';
          this.appendChild(field);
        }
        field.value = window.location.pathname + window.location.search + window.location.hash;
      }
      return originalSubmit.apply(this, arguments);
    };
  }

  function itemFromCard(target) {
    var card = target.closest && target.closest('.pmy-home-product-card, .pmy-cpg-card, .pmy-home-gallery__item, .pmy-home-city-card');
    if (!card) return null;
    var title = '';
    var titleEl = card.querySelector('.pmy-home-product-card__body h3, .pmy-cpg-title, h3, strong, span');
    if (titleEl) title = clean(titleEl.textContent, 200);
    var link = target.closest('a') || card.querySelector('a[href]');
    var href = link && link.getAttribute('href') || '';
    var id = href ? href.split('?')[0].replace(/\/$/, '').split('/').pop() : title;
    var listName = card.classList.contains('pmy-home-product-card') ? 'home_experiences' :
      card.classList.contains('pmy-cpg-card') ? 'collection_grid' :
      card.classList.contains('pmy-home-gallery__item') ? 'home_gallery' : 'home_city';
    return { item_id: clean(id, 200), item_name: title, item_list_name: listName };
  }

  /* PMY 2026-10-14: the hero switch fires pmy:country-change on document, and
     other components fire pmy:destination-change on window. Listen to both and
     send one pmy_destination_change per real change. */
  var lastDestinationSent = { value: '', at: 0 };

  function handleDestinationEvent(e) {
    if (!e || e.__pmyDestinationTracked) return;
    try { e.__pmyDestinationTracked = true; } catch (ignore) {}
    var detail = e.detail || {};
    var chosen = clean(detail.destination || detail.country || destination(), 50).toLowerCase();
    if (chosen === 'italia') chosen = 'italy';
    var now = Date.now();
    if (chosen && chosen === lastDestinationSent.value && now - lastDestinationSent.at < 1500) return;
    lastDestinationSent = { value: chosen, at: now };
    refreshAttribution();
    event('pmy_destination_change', {
      destination_selected: chosen,
      change_source: e.type === 'pmy:country-change' ? 'home_hero' : 'site_control'
    });
  }

  function setupInteractionTracking() {
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      var item = itemFromCard(target);
      if (item && target.closest('a[href]')) {
        event('select_item', {
          item_list_name: item.item_list_name,
          ecommerce: { item_list_name: item.item_list_name, items: [{ item_id: item.item_id, item_name: item.item_name, item_list_name: item.item_list_name }] }
        });
      }

      var category = target.closest('[data-pmy-home-category]');
      if (category) event('pmy_category_select', { category_handle: clean(category.getAttribute('data-pmy-home-category'), 100) });

      var tab = target.closest('[data-pmy-home-tab]');
      if (tab) event('pmy_category_tab', { category_handle: clean(tab.getAttribute('data-pmy-home-tab'), 100) });

      var service = target.closest('.pmy-platform-vertical[data-service]');
      if (service) event('pmy_service_change', { service: clean(service.getAttribute('data-service'), 50) });

      var destinationChoice = target.closest('.destination-option[data-destination], .pmy-mobile-destination');
      if (destinationChoice) event('pmy_destination_click', { destination_choice: clean(destinationChoice.getAttribute('data-destination') || destination(), 50) });

      var langChoice = target.closest('.pmy-lang-choice');
      if (langChoice) event('pmy_language_change', { language_label: clean(langChoice.textContent, 100) });

      var searchButton = target.closest('.pmy-platform-search button:last-child, .pmy-mobile-search-footer button');
      if (searchButton) {
        var cat = document.getElementById('pmy-platform-category');
        event('search', { search_term: cat && cat.value ? clean(cat.value, 100) : 'experiences' });
      }

      var bookingOpen = target.closest('.pmy-cpg-btn, .mobile-sticky-checkout button, .btn-verify-pmy');
      if (bookingOpen) {
        var titleEl = document.querySelector('.pdp-title') || (bookingOpen.closest('.pmy-cpg-card') && bookingOpen.closest('.pmy-cpg-card').querySelector('.pmy-cpg-title'));
        event('pmy_booking_open', { item_name: titleEl ? clean(titleEl.textContent, 200) : '' });
      }

      var share = target.closest('.btn-share-tour');
      if (share) event('share', { method: 'web_share', content_type: 'tour', item_id: handleFromPath(window.location.pathname) || clean(window.location.pathname.split('/').pop(), 200) });
    }, true);

    document.addEventListener('change', function (e) {
      var target = e.target;
      if (!target) return;
      if (target.id === 'pmy-currency-select') {
        event('pmy_currency_change', { currency_selected: clean(target.selectedOptions && target.selectedOptions[0] ? target.selectedOptions[0].textContent : target.value, 50) });
      }
    }, true);

    document.addEventListener('pmy:destination-change', handleDestinationEvent);
    window.addEventListener('pmy:destination-change', handleDestinationEvent);
    document.addEventListener('pmy:country-change', handleDestinationEvent);

    document.addEventListener('pmy:vertical-change', function (e) {
      event('pmy_service_change', { service: clean(e && e.detail && e.detail.vertical || '', 50) });
    });
  }

  function productViewItem() {
    var titleEl = document.querySelector('.pdp-title');
    var title = titleEl ? clean(titleEl.textContent, 200) : clean(document.title, 200);
    var item = {
      item_id: handleFromPath(window.location.pathname) || clean(window.location.pathname.split('/').pop(), 200),
      item_name: title,
      item_category2: destination()
    };
    try {
      var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
      if (meta) {
        if (meta.id) item.item_product_id = String(meta.id);
        if (meta.type) item.item_category = clean(meta.type, 100);
        var prices = (meta.variants || []).map(function (v) { return Number(v && v.price); }).filter(function (n) { return isFinite(n) && n > 0; });
        if (prices.length) item.price = money(Math.min.apply(Math, prices));
      }
    } catch (e) {}
    return item;
  }

  function emitViewEvents() {
    event('pmy_page_view', { page_title: clean(document.title, 200) });
    if (document.querySelector('.pdp-container')) {
      var item = productViewItem();
      var params = {
        currency: currency(),
        ecommerce: { currency: currency(), items: [item] }
      };
      if (item.price !== undefined) {
        params.value = item.price;
        params.ecommerce.value = item.price;
      }
      event('view_item', params);
    }
  }

  function completeActiveForms(reason) {
    var state = readFormState();
    Object.keys(state).forEach(function (formName) {
      event('pmy_form_complete', {
        form_name: formName,
        completion_reason: reason || 'checkout_started',
        started_at: state[formName] && state[formName].started_at || ''
      });
    });
  }

  function abandonForm(formName, reason) {
    formName = clean(formName || '', 100);
    if (!formName) return;
    var state = readFormState();
    if (!state[formName]) return;
    event('pmy_form_abandon', {
      form_name: formName,
      abandon_reason: reason || 'user_left_form',
      started_at: state[formName].started_at || '',
      transport_type: 'beacon'
    });
  }

  function abandonActiveForms(reason) {
    var state = readFormState();
    Object.keys(state).forEach(function (formName) {
      abandonForm(formName, reason || 'page_exit');
    });
  }

  function beginCheckout(items, meta) {
    items = Array.isArray(items) ? items : [];
    completeActiveForms('checkout_started');
    var summary = checkoutItemsWithValue(items);
    var value = summary.value !== undefined ? summary.value : currentValue();
    var params = {
      checkout_type: 'shopify_native',
      checkout_entry: 'explicit_checkout_start',
      item_count: getItemCount(items),
      value: value,
      currency: currency(),
      ecommerce: {
        currency: currency(),
        value: value,
        items: summary.items
      }
    };
    meta = meta && typeof meta === 'object' ? meta : {};
    Object.keys(meta).forEach(function (key) {
      if (meta[key] !== undefined && meta[key] !== null && meta[key] !== '') params[key] = meta[key];
    });
    event('pmy_checkout_start', params);
    event('begin_checkout', params);
  }

  /* ---------------------------------------------------------------------------
     PMY 2026-10-14: pmy_checkout_error. Fired whenever the booking checkout
     (PMYNativeCheckout.start) fails, with the step and the reason.
     --------------------------------------------------------------------------- */
  function errorStepFromMessage(message) {
    var m = String(message || '').toLowerCase();
    if (/no valid items/.test(m)) return 'validation';
    if (/reselect the date and time/.test(m)) return 'availability_input';
    if (/availability|no longer available|departure|hold was not created|could not be reserved/.test(m)) return 'availability_hold';
    if (/reset the booking cart/.test(m)) return 'cart_clear';
    if (/add items to cart/.test(m)) return 'cart_add';
    if (/save booking details/.test(m)) return 'cart_update';
    return 'unknown';
  }

  function checkoutError(error, payload) {
    var message = clean(error && error.message, 150);
    var failure = lastFlowFailure && Date.now() - lastFlowFailure.at < 30000 ? lastFlowFailure : null;
    var step = failure ? failure.step : errorStepFromMessage(message);
    var code = clean(error && error.code, 60) || (failure && failure.status ? 'http_' + failure.status : '');
    var lines = payload && (Array.isArray(payload.items) ? payload.items : (Array.isArray(payload.line_items) ? payload.line_items : []));
    event('pmy_checkout_error', {
      checkout_type: 'shopify_native',
      error_step: step,
      error_code: code || 'none',
      error_message: message,
      http_status: failure ? failure.status : 0,
      item_count: getItemCount(lines)
    });
  }

  function wrapNativeCheckout() {
    var nc = window.PMYNativeCheckout;
    if (!nc || typeof nc.start !== 'function' || nc.start.__pmyTracked) return;
    var original = nc.start;
    var wrapped = function () {
      var args = arguments;
      lastFlowFailure = null;
      var result;
      try {
        result = original.apply(this, args);
      } catch (err) {
        checkoutError(err, args[0]);
        throw err;
      }
      return Promise.resolve(result).catch(function (err) {
        checkoutError(err, args[0]);
        throw err;
      });
    };
    wrapped.__pmyTracked = true;
    nc.start = wrapped;
  }

  window.addEventListener('pagehide', function () {
    abandonActiveForms('page_exit');
  });

  window.PMYTracking = {
    getAttribution: function () { return JSON.parse(JSON.stringify(refreshAttribution())); },
    getOrderAttributes: orderAttributes,
    event: event,
    beginCheckout: beginCheckout,
    checkoutError: checkoutError,
    abandonForm: abandonForm,
    abandonActiveForms: abandonActiveForms,
    refresh: refreshAttribution
  };

  /* PMY 2026-10-14: load the click/form scripts together with this one.
     Before, they only loaded when the visitor accepted analytics AND marketing,
     so anyone who accepted only analytics vanished from WhatsApp clicks, form
     starts and product lists. Events only sit in the dataLayer; GTM loads after
     consent and its tags follow Consent Mode, so nothing is sent without it. */
  function loadCompanionScripts() {
    if (window.__pmyTrackingCompanionsLoaded) return;
    window.__pmyTrackingCompanionsLoaded = true;
    var src = SELF_SCRIPT && SELF_SCRIPT.src ? SELF_SCRIPT.src : '';
    if (!src || !/pmy-tracking\.js/.test(src)) return;
    var head = document.head || document.documentElement;
    ['pmy-tracking-micro.js', 'pmy-tracking-deep.js'].forEach(function (name) {
      var script = document.createElement('script');
      script.src = src.replace(/pmy-tracking\.js(?:\?.*)?$/, name + '?v=pmy20261014');
      script.async = false;
      head.appendChild(script);
    });
  }

  patchFetch();
  patchLocalizationSubmit();
  setupInteractionTracking();
  loadCompanionScripts();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      emitViewEvents();
      wrapNativeCheckout();
    }, { once: true });
  } else {
    emitViewEvents();
    wrapNativeCheckout();
  }
  window.addEventListener('load', wrapNativeCheckout, { once: true });
})();
